import { queryApi } from '../../../api'
import { ENDPOINT } from '../../../constants'
import { IAnsatt } from '../types'

export const orgenhetApi = {
  getAnsatt: (id: string) =>
    queryApi.get<IAnsatt>(`${ENDPOINT.ORGENHET}/ansatte/${id}`),
}
